
















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import allocationrulespo from "@/store/entities/finance/allocationrules/allocationrulespo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ChooseMeter from "./choosemeter.vue";
import moment from "moment";

@Component({
  components: { TreeSelect, ChooseMeter },
})
export default class CreateAllocationRules extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  allocationrulespo: allocationrulespo = new allocationrulespo();
  chooseModal: boolean = false; //选择窗体是否显示
  choosemeters: Array<any> = []; //已经选择表计
  isallocation: number = 1; //是否是公摊表，公摊为：105
  selecteddevice: Array<any> = [];
  allocationdevice: Array<any> = []; //待分配表计
  bearsdevice: Array<any> = []; //承担表计
  saving: boolean = false;

  created() {
    this.areaTree();
    this.allocationrulespo.isEnable = 1;
    this.getOrganizations();
  }
  get loading() {
    return this.$store.state.meterlist.loading;
  }
  create() { }
  //获取子组件回传值
  getdevicelist(data: any) {
    if (this.isallocation == 1) {
      data.forEach((ele) => {
        let le = this.bearsdevice.filter((bear) => {
          return bear.id == ele.id;
        });
        if (le.length == 0) {
          this.bearsdevice.push(ele);
        }
      });
    } else {
      data.forEach((ele) => {
        let le = this.allocationdevice.filter((bear) => {
          return bear.id == ele.id;
        });
        if (le.length == 0) {
          this.allocationdevice.push(ele);
        }
      });
    }
  }
  save() {
    (this.$refs.billperiodForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.allocationdevice.length == 0) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("PleaseChooseAllocationDevice"),
          });
          return;
        }
        if (this.bearsdevice.length == 0) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("PleaseChooseBearsDevice"),
          });
          return;
        }
        this.allocationrulespo.allocationedDevice = this.allocationdevice;
        this.allocationrulespo.bearsDevice = this.bearsdevice;
        this.saving = true;
        await this.$store
          .dispatch({
            type: "allocationrules/create",
            data: this.allocationrulespo,
          })
          .catch((err) => {
            this.saving = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.saving = false;
        (this.$refs.billperiodForm as any).resetFields();
        this.$emit("save-success");
        this.allocationdevice = [];
        this.bearsdevice = [];
        this.allocationrulespo.allocationedDevice = [];
        this.allocationrulespo.bearsDevice = [];
        this.$emit("input", false);
      }
    });
  }
  //选择待分配表计
  chooseallocationmeter() {
    if (this.allocationdevice.length > 0) {
      this.choosemeters = [];
      this.allocationdevice.forEach((ele) => {
        this.choosemeters.push(ele.id);
      });
    }
    this.isallocation = 105;
    this.chooseModal = true;
  }
  //选择承担表计
  choosebearsmeter() {
    this.choosemeters = [];
    if (this.bearsdevice.length > 0) {
      this.bearsdevice.forEach((ele) => {
        this.choosemeters.push(ele.id);
      });
    }
    this.isallocation = 1;
    this.chooseModal = true;
  }
  cancel() {
    (this.$refs.billperiodForm as any).resetFields();
    this.$emit("input", false);
  }
  //区域
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  allocationcolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 180,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("ControleType"),
      key: "controleType",
      width: 130,
      sortable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.controleType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("ReadTime"),
      key: "lastReadTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("LastReadNum"),
      key: "lastReadNum",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("CurrentTenant"),
      key: "customerName",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: () => {
                      this.delerecordallocation(params.row);
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  //承担设备列
  bearscolumns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("Meter"),
      key: "meterNo",
      sortable: true,
      width: 180,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      title: this.L("ControleType"),
      key: "controleType",
      width: 130,
      sortable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.controleType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : "未知");
      },
    },
    {
      title: this.L("ReadTime"),
      key: "lastReadTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("LastReadNum"),
      key: "lastReadNum",
      width: 150,
      sortable: true,
    },
    {
      title: this.L("CurrentTenant"),
      key: "customerName",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: () => {
                      this.delerecordbears(params.row);
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  //删除分摊表计
  delerecordallocation(val: any) {
    this.allocationdevice = this.allocationdevice.filter((ele) => {
      return ele.id != val.id;
    });
  }
  //删除承担表计
  delerecordbears(val: any) {
    this.bearsdevice = this.bearsdevice.filter((ele) => {
      return ele.id != val.id;
    });
  }
  //规则
  ruleValidate = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("Organizations") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rules: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [], //区域
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
